export const CONTACT_EMAIL = 'contact@coliboddy.fr';